import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  useTheme,
  useMediaQuery,
  Container,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Select,
  MenuItem,
} from "@mui/material";
import { decryptData } from "../../../crypto";
import useHeaderStyles from "../testStyle/ipmatStyle/headerStyle";
import { ReactComponent as InfoIcon } from "../../../images/Info.svg";
import { ReactComponent as Question } from "../../../images/Question.svg";
import QuestionPaper from "./QuestionPaper";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import { useLanguages } from "../../../context/LanguagesContext";
import Fab from "@mui/material/Fab";
// import HoverInfo from "./hoverInfo";
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';

const Header = ({ children, activeSubjectId }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [openInstructions, setOpenInstructions] = useState(false);
  const [openQuestion, setOpenQuestion] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(!!document.fullscreenElement);
  const classes = useHeaderStyles();

  // React.useEffect(() => {
  //   const handleFullscreenChange = () => {
  //     setIsFullscreen(!!document.fullscreenElement);
  //   };
  //   document.addEventListener("fullscreenchange", handleFullscreenChange);
  //   return () => document.removeEventListener("fullscreenchange", handleFullscreenChange);
  // }, []);

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch((err) => {
        console.error("Fullscreen error:", err);
      });
    }
  };

  const { languages, handleChange, selectedLanguage } = useLanguages();

  const handleOpenInstructions = () => {
    setOpenInstructions(true);
  };

  const handleCloseInstructions = () => {
    setOpenInstructions(false);
  };
  const handleOpenQuestion = () => {
    setOpenQuestion(true);
  };

  const handleCloseQuestion = () => {
    setOpenQuestion(false);
  };

  const examInstructions =
    sessionStorage.getItem("examInstructions") ||
    "No instructions available. Please check with your exam administrator.";

  return (
    <div className={classes.headerContainer}>
      {/* Floating Fullscreen Button */}
        {/* {!isFullscreen && (
        <Fab
          color="primary"
          aria-label="fullscreen"
          onClick={toggleFullscreen}
          sx={{
            position: "fixed",
            top: 30,
            right: "45%",
            zIndex: 9999,
            backgroundColor: "#1374aa",
            "&:hover": { backgroundColor: "#104a77" },
            animation: "pulse 2s infinite",
            "@keyframes pulse": {
              "0%": { boxShadow: "0 0 0 0 rgba(19, 116, 170, 0.4)" },
              "70%": { boxShadow: "0 0 0 15px rgba(19, 116, 170, 0)" },
              "100%": { boxShadow: "0 0 0 0 rgba(19, 116, 170, 0)" }
            }
          }}
        >
          <KeyboardDoubleArrowUpIcon />
        </Fab>
      )} */}
      {/* Top Blue Bar */}
      {/* <AppBar position="static" className={classes.topBlueBar}>
        <Toolbar className={classes.toolbarCenter}>
          <Typography className={classes.clientLogoText}>
            CLIENT LOGO
          </Typography>
        </Toolbar>
      </AppBar> */}

      {/* Black Bar */}
      <Box className={classes.blackBar}>
          {
                  isMobile && <Typography
                    variant="subtitle1"
                    className={classes.examTitle}
                    sx={{
                      // maxWidth: { xs: "50vw", sm: "60vw" },
                      lineHeight: 1.2,
                      wordBreak: "break-word",
                      paddingY: 0.5,
                      fontSize: { xs: "0.75rem", sm: "1rem" },
                    }}
                  >
                    {decryptData(sessionStorage.getItem("exam_name"))}
                  </Typography>
                }
        <div className={classes.blackBarContainer}>
          {/* Left text */}
          {
            !isMobile && <Typography
            variant="subtitle1"
            className={classes.examTitle}
            sx={{
              maxWidth: { xs: "50vw", sm: "60vw" },
              lineHeight: 1.2,
              wordBreak: "break-word",
              paddingY: 0.5,
              fontSize: { xs: "0.75rem", sm: "1rem" },
            }}
          >
            {decryptData(sessionStorage.getItem("exam_name"))}
          </Typography>

          }
       
          {/* Right icons */}
          <Box
            className={`${classes.iconsContainer} ${isMobile ? classes.mobileMarginTop : ""
              }`}
          >
            <Box className={classes.iconTextGroup}>
              {/* <Question  />
              <Typography variant="body2">Question paper</Typography> */}
              <Select
                value={selectedLanguage}
                onChange={handleChange}
                size="small"
                sx={{
                  background: "white",
                  height: { xs: "24px", sm: "30px" },
                  fontSize: { xs: "0.65rem", sm: "0.875rem" },
                  minWidth: { xs: "65px", sm: "auto" },
                  "& .MuiSelect-select": {
                    paddingTop: "1px !important",
                    paddingBottom: "1px !important",
                    display: "flex",
                    alignItems: "center",
                  },
                }}
              >
                {languages?.map((l, i) => (
                  <MenuItem key={i} value={l.value}>
                    {l.label}
                  </MenuItem>
                ))}

                {/* <MenuItem value="Hindi">Hindi</MenuItem> */}
              </Select>
            </Box>
            <Box
              className={`${classes.iconTextGroup} ${classes.instructionsIcon}`}
              onClick={handleOpenInstructions}
            >
              <InfoIcon />
              <Typography variant="body2">Instruction</Typography>
            </Box>
            <Box
              className={`${classes.iconTextGroup} ${classes.instructionsIcon}`}
              onClick={handleOpenQuestion}
            >
              <Question />
              <Typography variant="body2">Question Paper</Typography>
            </Box>
            <Box
              className={`${classes.iconTextGroup} ${classes.instructionsIcon}`}
            // onClick={handleOpenQuestion}
            >

              {children}
            </Box>
          </Box>
        </div>
      </Box>

      {/* Instructions Dialog */}
      <Dialog
        open={openInstructions}
        onClose={handleCloseInstructions}
        maxWidth={false}
        fullScreen={isMobile}
        PaperProps={{
          style: isMobile ? {} : {
            width: "min(80vw, 900px)",
            height: "80vh",
            maxWidth: "95vw",
          },
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: "#1374aa",
            p: 0, // removes default padding
            overflow: "hidden",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              paddingLeft: "16px",
              paddingRight: "16px",
              color: "white",
            }}
          >
            <span>Exam Instructions</span>
            <IconButton onClick={handleCloseInstructions} edge="end">
              <CloseIcon style={{ color: "white" }} />
            </IconButton>
          </div>
        </DialogTitle>

        <DialogContent>
          <DialogContentText className={classes.instructionsDialogContent}>
            <div
              dangerouslySetInnerHTML={{
                __html: decryptData(examInstructions),
              }}
            />
          </DialogContentText>
        </DialogContent>
      </Dialog>

      <Dialog
        open={openQuestion}
        onClose={handleCloseQuestion}
        maxWidth="lg"
        fullWidth
        fullScreen={isMobile}
        PaperProps={{
          style: isMobile ? {} : {
            width: "min(80vw, 900px)",
            height: "80vh",
            maxWidth: "95vw",
          },
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: "#1374aa",
            p: 0,
            overflow: "hidden",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              paddingLeft: "16px",
              paddingRight: "16px",
              color: "white",
            }}
          >
            <span>Question Paper</span>
            <IconButton onClick={handleCloseQuestion} edge="end">
              <CloseIcon style={{ color: "white" }} />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent
          sx={{
            overflowX: "hidden",
            p: 2,
          }}
        >
          <Box className={classes.instructionsDialogContent}>
            <QuestionPaper activeSubjectId={activeSubjectId} />
          </Box>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Header;
